<div class="modal-body">
  <div class="col d-flex justify-content-end">
    <button
      type="button"
      class="btn-close btn-close-red"
      aria-label="Close"
      (click)="dismiss()"
    ></button>
  </div>

  <h4
    class="col d-flex justify-content-center my-8 text-center"
    [innerHtml]="'CANADIAN_CUSTOMER_MODAL.HEADER_TEXT' | translate"
  ></h4>

  <div class="col margin-m d-flex justify-content-center align-items-center">
    <p class="m-0 w-auto px-5">
      <strong
        class="d-flex justify-content-center text-center"
        [innerHtml]="'CANADIAN_CUSTOMER_MODAL.BODY_TEXT' | translate"
      ></strong>
    </p>
  </div>

  <digital-platform-cta-button
    class="col d-flex justify-content-center margin-m my-8"
    [ctaSize]="createCMSObject('ctaSize', 'button__lg')"
    [ctaStyle]="createCMSObject('ctaStyle', 'btn-primary')"
    (click)="navigateToWasteco()"
    ><digital-platform-icon
      class="check-icon"
      icon="check-circle-solid"
      color="secondary"
      [height]="24"
      [width]="24"
    ></digital-platform-icon>
    <div class="pseudo-icon-fill"></div>
    {{
      'CANADIAN_CUSTOMER_MODAL.CTA_BUTTON_TEXT' | translate
    }}</digital-platform-cta-button
  >

  <digital-platform-rsx-a
    class="col d-flex justify-content-center custom-rsx-a-style margin-m"
    styling="color: var(--bs-red); text-decoration: none;"
    (click)="dismiss()"
    ><strong>{{
      'CANADIAN_CUSTOMER_MODAL.STAY_ON_REPUBLIC_SERVICES' | translate
    }}</strong></digital-platform-rsx-a
  >
</div>
